import React from 'react';

class Highlights extends React.Component {
    componentDidMount() {

    }

    render() {

        var highlightimages = [
            "./assets/images/highlights/IMG-20231117-WA0022.png",
            './assets/images/highlights/IMG-20231117-WA0021.png'
        ]
        var list = (highlightimages.map(function (item) {
            return <img src={item} class='bigimage' />;
        }));

        var disclaimer = (
            <div class='fullwidthcontainer'>
                <div class='fullwidthcontainer'>
                    <div class='disclaimer center margintopnbottom'>
                        Highlights aus dem Augenstern Sortiment finden Sie in Zukunft hier!
                    </div>
                </div>
            </div>
        );

        return list;
    }
}

export default (Highlights);